import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const buildingDisplayNameField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Facility ID',
    context: 'The display name for the building',
  }),
};

export const buildingCommonFields = {
  building_display_name: buildingDisplayNameField,
  building_lease_type: {
    displayName: msg({
      message: 'Facility lease type',
      context: 'The display name for the building lease type field',
    }),
    externalDescription: msg({
      message: 'The lease type of the facility.',
      context: 'Facility lease type',
    }),
  },
  building_kind: {
    displayName: msg({
      message: 'Facility kind',
      context: 'The display name for the building kind field',
    }),
    externalDescription: msg({
      message: 'The type of facility.',
      context: 'Facility kind',
    }),
  },
  building_subkind: {
    displayName: msg({
      message: 'Facility subkind',
      context: 'The display name for the building subkind field',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;

export const buildingRevisionFields = {
  revision: {
    displayName: msg({
      message: 'Building revision',
      context: 'The display name for the building revision field',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
